import React from 'react';
import { Box, Container, Stepper, Step, StepLabel } from '@mui/material';
import AppHeader from './AppHeader';
import BottomNav from './BottomNav';
import { useAlbum } from '../../contexts/AlbumContext';

const steps = ['업로드', '처리', '편집', '생성'];

const MainLayout = ({ children }) => {
  const { step } = useAlbum();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
        bgcolor: 'background.default',
      }}
    >
      <AppHeader />

      {/* Spacer for fixed AppBar */}
      <Box sx={{ height: 56 }} />

      {/* Step Indicator */}
      <Box
        sx={{
          bgcolor: 'background.paper',
          py: 2,
          px: 1,
          borderBottom: '1px solid',
          borderColor: 'divider',
        }}
      >
        <Container maxWidth="sm">
          <Stepper
            activeStep={step - 1}
            alternativeLabel
            sx={{
              '& .MuiStepLabel-label': {
                fontSize: '0.75rem',
                marginTop: '4px',
              },
              '& .MuiStepConnector-line': {
                borderTopWidth: 2,
              },
              '& .MuiStepConnector-root.Mui-active .MuiStepConnector-line': {
                borderColor: 'primary.main',
              },
              '& .MuiStepConnector-root.Mui-completed .MuiStepConnector-line': {
                borderColor: 'primary.main',
              },
            }}
          >
            {steps.map((label, index) => (
              <Step key={label} completed={step > index + 1}>
                <StepLabel>{label}</StepLabel>
              </Step>
            ))}
          </Stepper>
        </Container>
      </Box>

      {/* Main Content */}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          overflow: 'auto',
          pb: 10, // Space for bottom nav
        }}
      >
        <Container maxWidth="sm" sx={{ py: 2 }}>
          {children}
        </Container>
      </Box>

      <BottomNav />
    </Box>
  );
};

export default MainLayout;
